import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PermissionLevel } from '../core/permissions/permission-levels.enum';
import { RequestAppointmentV2Component } from './request-appointmentv2.component';

const routes: Routes = [
	{
		path: '',
		component: RequestAppointmentV2Component,
		data: { permissionLevel: PermissionLevel.REQUEST_APPOINTMENT }
	}
];

@NgModule({
	imports: [RouterModule.forChild(routes)],
	exports: [RouterModule]
})
export class RequestAppointmentV2RoutingModule { }
